module.exports = __webpack_public_path__ + "static/assets/c6b29462f79d8eafcd438b2f9d402ad4.svg";